import { MINUTE } from 'Utilities/consts';

export const HOURS = 'H[h]';
export const HOUR_MINUTES = 'H[h] m[m]';
export const HOUR_MINUTES_AM_PM = 'h:mma';
export const HOUR_AM_PM = 'ha';
export const MINUTES_SECONDS = 'm[m] s[s]';

/* eslint-disable sort-keys-fix/sort-keys-fix */
// These are used to determine the format of the time between different time points and the colouring
// e.g 59th minute will use 59m 0s, 29th minute will use red colour etc.
export const LAST_HOUR_MINUS_ONE = {
	start: 60 * MINUTE - 1,
	end: 1 * MINUTE,
	format: MINUTES_SECONDS,
};

export const LAST_30_MIN_MINUS_ONE = {
	start: 30 * MINUTE - 1,
	end: 1 * MINUTE,
	format: MINUTES_SECONDS,
};

export const LAST_MIN = {
	start: 1 * MINUTE,
	end: 0,
	format: 's[s]',
};
/* eslint-enable sort-keys-fix/sort-keys-fix */
